import { useCallback } from 'react';

interface UseVideoLoadingHandlersParams {
  setVideo1Loading: (loading: boolean) => void;
  setVideo2Loading: (loading: boolean) => void;
}

export const useVideoLoadingHandlers = ({
  setVideo1Loading,
  setVideo2Loading,
}: UseVideoLoadingHandlersParams) => {
  const handleVideo1LoadingChange = useCallback(
    (loading: boolean) => {
      setVideo1Loading(loading);
    },
    [setVideo1Loading],
  );

  const handleVideo2LoadingChange = useCallback(
    (loading: boolean) => {
      setVideo2Loading(loading);
    },
    [setVideo2Loading],
  );

  return {
    handleVideo1LoadingChange,
    handleVideo2LoadingChange,
  };
};
